var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import parse from 'color-parse';
export var parseColor = function (color) {
    if (color == null) {
        throw Error('Undefined / null color given to parseColor');
    }
    if (color.space) {
        return color;
    }
    return parse(color);
};
export var stringifyColor = function (color) {
    if (color == null) {
        throw Error('Undefined / null color given to parseColor');
    }
    if (color.space) {
        var parsedColor = color;
        if (parsedColor.space === 'rgb') {
            return "rgba(".concat(__spreadArray(__spreadArray([], parsedColor.values, true), [parsedColor.alpha], false).join(','), ")");
        }
        throw Error('stringifyColor only handle colors with an rgb space (hex, rgb, rgba)');
    }
    return color;
};
export var applyOpacityToColor = function (color, opacity) {
    var parsedColor = parseColor(color);
    return __assign(__assign({}, parsedColor), { alpha: parsedColor.alpha * opacity });
};
export var isColorDark = function (color) {
    var _a = parseColor(color), values = _a.values, alpha = _a.alpha;
    var colorDarkness = (values[0] + values[1] + values[2]) / alpha;
    return colorDarkness < (255 * 3) / 2;
};
//# sourceMappingURL=color.js.map